import { render, staticRenderFns } from "./terminosCondicionesCliente.vue?vue&type=template&id=4e295224&scoped=true&"
import script from "./terminosCondicionesCliente.vue?vue&type=script&lang=js&"
export * from "./terminosCondicionesCliente.vue?vue&type=script&lang=js&"
import style0 from "./terminosCondicionesCliente.vue?vue&type=style&index=0&id=4e295224&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e295224",
  null
  
)

export default component.exports